import React from 'react'
import { useHistory } from 'react-router-dom'

function Dashboard() {
  let { location } = useHistory()

  return (
    <div
      style={{
        color: `${location.pathname === '/' ? '#2ACC96' : 'white'}`,
      }}
    >
      Dashboard
    </div>
  )
}

export default Dashboard
